export default () => ({
  paper: {
    background: "#eceff1",
    padding: 4,
    color: "#424242",
  },
});
